import React from 'react';
export function FinalCTA() {
  return <section className="bg-black py-4 px-4 text-center" data-id="element-163">
      <div className="max-w-4xl mx-auto" data-id="element-164">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-2" data-id="element-165">
          ¿Listo/a para transformar tu año en{' '}
          <span className="text-[#22c55e]" data-id="element-166">Educación Financiera</span>?
        </h2>
        <p className="text-xl text-gray-300 mb-3" data-id="element-167">
          Sumate a docentes que ya dejaron de improvisar.
        </p>
      </div>
    </section>;
}